// extracted by mini-css-extract-plugin
module.exports = {"DisciplinesPage":"DisciplinesPage_DisciplinesPage__9rGJc","CoursesPageOverflow":"DisciplinesPage_CoursesPageOverflow__1P1We","CoursesPage":"DisciplinesPage_CoursesPage__32Gfv"};